module.exports = __webpack_public_path__ + "static/media/spring.9a3b63ed.svg";